module.exports = __webpack_public_path__ + "img/Save-Btn.ea78fd9d.svg";